import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { DxValidatorModule } from 'devextreme-angular';
import { WebsiteFormService } from './website-form.service';
import { WebsiteFormComponent } from './website-form.component';

@NgModule({
  imports: [SharedModule, DxValidatorModule],
  declarations: [WebsiteFormComponent],
  exports: [WebsiteFormComponent],
  providers: [WebsiteFormService],
})
export class WebsiteFormModule {}
